import { useMemo } from 'react'
import { useLocation } from 'react-router'
import { FeedPageParams } from '@/feed/Feed.interface'
import { getCaseSensitiveParams } from '@/lib/utils'

/**
 * Reads the SDK credentials out of the query string.
 *
 * Parsing goes through getCaseSensitiveParams rather than URLSearchParams so
 * that a literal `+` in sdkAppKey survives: URLSearchParams decodes `+` as a
 * space, which would corrupt the `x-key` header.
 */
export default function usePageParams(): FeedPageParams {
  const { search } = useLocation()

  return useMemo(() => {
    const raw = getCaseSensitiveParams(search)
    // The API and the native SDKs send these keys in several casings.
    const pick = (...keys: string[]) =>
      keys.map((key) => raw[key]).find((value) => value) ?? ''

    return {
      alias: pick('alias', 'Alias'),
      sdkAppId: pick('sdkAppId', 'sdk_app_id', 'SdkAppId'),
      sdkAppKey: pick('sdkAppKey', 'sdk_app_key', 'SdkAppKey')
    }
  }, [search])
}
